<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>人事管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="员工姓名" prop="name">
            <el-input v-model="search.name" placeholder="请输入员工姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="员工状态" prop="status">
            <el-select clearable class="width-max" v-model="search.status" placeholder="请选择员工状态">
              <el-option label="在职" :value="1" />
              <el-option label="离职" :value="2" />
              <el-option label="冻结" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="search.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="邮箱" prop="email">
            <el-input v-model="search.email" placeholder="请输入邮箱" clearable></el-input>
          </el-form-item> -->
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" native-type="submit">搜索</el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary" size="small" @click="onCreateEmployee()">新增员工</el-button>
        <el-button type="primary" size="small" @click="onWechatImport()">导入员工明细表</el-button>
        <el-upload ref="employeeImportUploader"
                   style="display: none"
                   action=""
                   accept=".xlsx,.xls"
                   :http-request="uploadEmployeeFile"
                   :show-file-list="false"/>
        <el-button type="primary" size="small" @click="onEmailExport()">导出邮件发送明细表</el-button>
        <el-button type="success" size="small" style="float: right" @click="onViewBirthdayGreetingPending()">生日定时列表</el-button>
      </div>
      <el-table ref="multipleTable"
                :data="table"
                border
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="name" label="员工姓名" align="center"/>
        <el-table-column prop="status" label="员工状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="mini">
              {{ formatEmployeeStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" />
        <el-table-column prop="email" label="邮箱" align="center" />
        <el-table-column prop="birthday" label="生日" align="center" />
        <el-table-column prop="hire_date" label="入职日期" align="center" />
        <el-table-column fixed="right" label="操作" width="240" align="center">
          <template slot-scope="scope">
            <div class="op-actions">
              <el-button size="mini" type="text" @click="onAddBirthdayGreeting(scope.row)">设置生日邮件</el-button>
              <el-button size="mini" type="text" @click="onViewDetail(scope.row)">详情</el-button>
              <el-button size="mini" type="text" @click="onEditEmployee(scope.row)">编辑</el-button>
              <el-button class="delete-action" size="mini" type="text" @click="onDeleteEmployee(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <!-- 邮件记录导出弹窗 -->
    <email-export-dialog
      v-if="emailExportVisible"
      :visible.sync="emailExportVisible"
      :loading="emailExportLoading"
      @confirm="onEmailExportConfirm"
    />
    <birthday-gift-dialog
      v-if="birthdayGiftVisible"
      :visible.sync="birthdayGiftVisible"
      :loading="birthdayGiftLoading"
      :row="birthdayGiftRow"
      @confirm="onBirthdayGiftConfirm"
      @cancel="onBirthdayGiftCancel"
    />
  </div>
</template>

<script>
import table from '@core/mixins/table'
import { searchRules } from '../../hr.rules'
import EmailExportDialog from '@/views/hr/components/EmailExportDialog.vue'
import BirthdayGiftDialog from '@/views/hr/component/BirthdayGiftDialog.vue'
import downloadJS from '@/vendor/download'

export default {
  mixins: [table],
  components: {
    EmailExportDialog,
    BirthdayGiftDialog,
  },
  data () {
    return {
      searchRules,
      // 搜索条件（会同步到路由 query，并参与列表请求）
      search: {
        name: '',
        status: null,
        phone: '',
        email: '',
      },
      // 搜索字段类型声明（用于从路由 query 同步回来时做类型转换）
      searchFieldType: {
        status: Number,
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      emailExportVisible: false,
      emailExportLoading: false,
      birthdayGiftVisible: false,
      birthdayGiftLoading: false,
      birthdayGiftRow: null,
    }
  },
  methods: {
    /**
     * 获得表格数据（table mixin 会自动把 search + pagination 合并进来）
     */
    getTableData (params) {
      return request.page('getEmployeeList', params)
    },
    formatEmployeeStatus (status) {
      const v = Number(status)
      if (v === 1) return '在职'
      if (v === 2) return '离职'
      if (v === 3) return '冻结'
      return status === null || status === undefined || status === '' ? '-' : String(status)
    },
    statusTagType (status) {
      const v = Number(status)
      if (v === 1) return 'success'
      if (v === 2) return 'info'
      if (v === 3) return 'danger'
      return ''
    },
    onCreateEmployee () {
      this.$router.push('/hr/employee/add')
    },
    onViewDetail (row) {
      this.$router.push(`/hr/employee/detail/${row.id}`)
    },
    /**
     * 重置搜索：清空表单 + 回到第一页 + 触发重新查询
     */
    resetSearch () {
      const form = this.$refs.searchForm
      form && form.resetFields()
      this.onSearch()
    },
    onEditEmployee (row) {
      this.$router.push(`/hr/employee/update/${row.id}`)
    },
    onViewBirthdayGreetingPending () {
      this.$router.push('/hr/employee/birthday-list')
    },
    onAddBirthdayGreeting (row) {
      this.birthdayGiftRow = row || null
      this.birthdayGiftVisible = true
    },
    onBirthdayGiftConfirm (payload) {
      const row = this.birthdayGiftRow
      const params = {
        employee_id: row && row.id ? row.id : null,
        gift: payload && payload.gift ? payload.gift : '',
        bcc: payload && payload.birthday_bcc ? payload.birthday_bcc : [],
      }
      this.birthdayGiftLoading = true
      request.common('addBirthdayGreetings', params).then(() => {
        this.$message.success('保存成功')
        this.birthdayGiftRow = null
        this.onRefresh()
      }).finally(() => {
        this.birthdayGiftVisible = false
        this.birthdayGiftLoading = false
      })
    },
    onBirthdayGiftCancel () {
      this.birthdayGiftVisible = false
      this.birthdayGiftRow = null
    },
    // 员工删除
    onDeleteEmployee (row) {
      this.$confirm('确定删除该员工吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('deleteEmployee', row.id).then(() => {
          this.$message.success('删除成功')
          this.onRefresh()
        })
      })
    },
    // 邮件记录导出
    onEmailExport () {
      this.emailExportVisible = true
    },
    onEmailExportConfirm (payload) {
      this.emailExportLoading = true
      request.dispatch('exportEmployeeGreetings', payload).then((res) => {
        const typeText = payload && payload.type === 1 ? '入职周年庆' : '生日祝福'
        downloadJS(res.data, `${typeText}邮件发送明细表.xlsx`)
        this.$message.success('导出成功')
      }).finally(() => {
        this.emailExportLoading = false
        this.emailExportVisible = false
      })
    },
    // 企业微信一键导入
    onWechatImport () {
      const uploader = this.$refs.employeeImportUploader
      if (uploader && uploader.$refs['upload-inner']) {
        uploader.$refs['upload-inner'].handleClick()
      }
    },
    uploadEmployeeFile (file) {
      const fileName = file && file.file && file.file.name ? file.file.name.toLowerCase() : ''
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        this.$message.error('仅支持上传 xls/xlsx 文件')
        return false
      }
      const formData = new FormData()
      formData.append('file', file.file)
      request.common('importEmployees', formData).then(() => {
        this.$message.success('导入成功')
        this.onRefresh()
      })
    },
  }
}
</script>


<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.op-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.delete-action {
  color: #F56C6C;
}
</style>




// WEBPACK FOOTER //
// src/views/hr/pages/employee/list.vue